import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { oauthConsentHashRoute } from "./components/supabase/oauth-consent-route";
import { rememberTvPairingLink } from "./components/atomic-crm/tv/pairingHandoff";
rememberTvPairingLink();

const consentRoute = oauthConsentHashRoute(new URL(window.location.href));
if (consentRoute) window.history.replaceState(null, "", consentRoute);

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// See https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", () => {
  const key = "chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
